module.exports = __webpack_public_path__ + "static/media/pic3.07b810a8.jpg";